<template>
  <AwButton variant="ghost" size="sm" class="!px-1.5" @click="toggleSidebarCollapse()">
    <AwIcon :name="sidebarToggleIconName" class="size-4 text-secondary-800" />
  </AwButton>
</template>

<script setup lang="ts">
import { useSidebar } from "~/composables/useSidebar";
const { isSidebarCollapsed, toggleSidebarCollapse } = useSidebar();

const sidebarToggleIconName = computed(() =>
  isSidebarCollapsed.value ? "i-ph-sidebar-simple" : "i-ph-sidebar-simple-fill"
);
</script>
